<template>
  <div class="banner">
    <div
      class="banner__image"
      data-aos="fade-down"
      data-aos-duration="500"
        ref="bannerRef"
    >
      <img :src="bannerImage" alt="" />
    </div>
    <div class="container">
      <div
        v-if="heading || headingHighlight"
        :class="[ 'banner__content', { 'banner__content--extra': showExtraContent } ]"
      >
        <div
          class="banner__content-wrapper"
          :class="[{ 'trun-left': isScrolled }]"
        >
          <div v-if="headingHighlight" class="heading-hightlight">
            {{ headingHighlight }}
          </div>
          <div v-if="heading" class="heading" v-html="heading"></div>
        </div>
        <div v-if="showExtraContent" class="banner__content-extra">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

defineProps({
  heading: String,
  headingHighlight: String,
  bannerImage: {
    type: String,
    required: true,
  },
  showExtraContent: {
    type: Boolean,
    default: false,
  },
});

const bannerRef = ref();
const isScrolled = ref(false);


const onBannerScroll = () => {
  const scrollPosition = window.scrollY;
  isScrolled.value = scrollPosition > 100;

  if (bannerRef.value) {
    bannerRef.value.classList.toggle("curve", scrollPosition > 100);
  }
};

onMounted(() => {
  window.addEventListener("scroll", onBannerScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onBannerScroll);
});
</script>



<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .heading {
      @include font-size("display-4", $lang);
      line-height: 1;
      text-indent: 5rem;
      @include media-breakpoint-down(sm) {
        text-indent: 2rem;
        @include font-size("h3", $lang);
      }
    }

    .heading-hightlight {
      @include font-size("display-4", $lang);
      line-height: 1;
      text-align: start;
      @include media-breakpoint-down(sm) {
        @include font-size("h3", $lang);
      }
    }
    .banner__content--extra {
      .heading {
        @include font-size("h2", $lang);
      }
      .heading-hightlight {
        @include font-size("h2", $lang);
      }
    }
  }
}

.banner {
  // position: relative;
  .banner__image {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 70dvh;
      object-fit: cover;
      object-position: top;
      @include transition(1s);
    }
    &.curve {
      img {
        width: 90%;
        border-radius: 60rem;
        @include media-breakpoint-down(md) {
          border-radius: 5rem;
        }
      }
    }
  }

  .banner__content {
    color: $black;
    display: flex;
    // justify-content: center;
    // align-items: center;
    padding: 50px 0 50px 0;
      position: relative;
      min-height: 220px;
    @include media-breakpoint-down(sm) {
      flex-direction: column;
    }
 
    .banner__content-wrapper {
      width: max-content;
      margin-right: 0;
      transition: all 1s ease-in-out;
      position: relative;
      top: 55px;
      left: 50%;
      -ms-transform: translate(-50%, 0%);
      transform: translate(-50%, 0%);

      &.trun-left {
        left: 0;
        -ms-transform: translate(0%, 0%);
        transform: translate(0%, 0%);
        @include media-breakpoint-down(sm) {
          margin-right: 5%;
    }
      }
    }

    &.banner__content--extra {
      justify-content: space-between;
      margin: 0 5.6rem;
      .trun-left {
        margin-right: 0;
      }
    }
  }
}
</style>